import instanceService from "./instance";

import { CASH_BOX_SERVER_URL, CLIENT_SERVER_URL } from "../helpers/constants";

let instance = instanceService.instance(CASH_BOX_SERVER_URL);
let instanceCalculate = instanceService.instance(CLIENT_SERVER_URL);

export const debtLoadService = { getDebtLoadList, putDebtLoadGroup, getDebtLoadGroup, getDebtLoadClientCalculate, getClientLastDebtLoad };

function getDebtLoadList(date) {
  const options = {
    method: "GET",
    params: date,
    url: "/debt-load/list",
  };
  return instance(options);
}

function getDebtLoadGroup({groupName}) {
  const options = {
    method: "GET",
    url: `/debt-load/${groupName}`
  };
  return instance(options);
}

function putDebtLoadGroup({ groupName, values }) {
  return instance({
    method: "PUT",
    url: `/debt-load/${groupName}`,
    data: { values }
  });
}

function getDebtLoadClientCalculate({ clientId, values }) {
  return instanceCalculate({
    method: "POST",
    url: `/debt-load/${clientId}/calculate`,
    data: values
  });
}

function getClientLastDebtLoad({ clientId }) {
  return instanceCalculate({
    method: "GET",
    url: `/debt-load/${clientId}`
  });
}
